/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from 'views/ActionDrawer/components/ActionDrawerHeader/ActionDrawerHeader';

import Form from 'forms/_.extend';

import DisableAccountMultiForm from './DisableAccountMultiForm/DisableAccountMultiForm';
import DisableAccountMultiSuccess from './DisableAccountMultiSuccess/DisableAccountMultiSuccess';
import DisableAccountMultiError from './DisableAccountMultiError/DisableAccountMultiError';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  currentAccountDetails: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class DisableAccountMulti extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const currentAccountDetails: Object = this.props.currentAccountDetails;
    const fields: Array<Object> = [
      {
        name: 'disableAccountForm',
        label: t('general:actions.disable_account_plural'),
        title: 'Disable Accounts',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_disabling'),
            rules: 'required',
            value: '',
            type: 'select',
            options: [
              {
                id: 1,
                label: t('general:reasons.options.accounts_no_longer_in_use'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const accountIds = currentAccountDetails.map(account => account.id);
        const { reason } = data.values().disableAccountForm;

        actionDrawerStore.enableDisableAccountMulti({
          is_enabled: false,
          activity_reason: reason,
          account_ids: accountIds,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: 'disableAccountMulti',
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { currentAccountDetails, actionDrawerStore }: TypeProps = this.props;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.disable_account_plural')} />
          <DisableAccountMultiError
            currentAccountDetails={currentAccountDetails}
            response={actionDrawerStore.response}
          />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.disabled}`}>
          <ActionDrawerHeader title={t('general:actions.disable_account_plural')} />
          <DisableAccountMultiSuccess
            currentAccountDetails={currentAccountDetails}
            response={actionDrawerStore.response}
          />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.disable_account_plural')} />
        <DisableAccountMultiForm
          currentAccountDetails={currentAccountDetails}
          form={this.createForm()}
        />
      </div>
    );
  }
}
